function richTextToHtml(node) {
  if (!node) return '';

  switch (node.type) {
    case 'root':
      return node.children.map(richTextToHtml).join('');

    case 'paragraph':
      return '<p>' + node.children.map(richTextToHtml).join('') + '</p>';

    case 'heading':
      var tag = 'h' + (node.level || 2);
      return '<' + tag + '>' + node.children.map(richTextToHtml).join('') + '</' + tag + '>';

    case 'list':
      var listTag = node.listType === 'ordered' ? 'ol' : 'ul';
      return '<' + listTag + '>' + node.children.map(richTextToHtml).join('') + '</' + listTag + '>';

    case 'list-item':
      return '<li>' + node.children.map(richTextToHtml).join('') + '</li>';

    case 'link':
      return '<a href="' + (node.url || '') + '">' + node.children.map(richTextToHtml).join('') + '</a>';

    case 'text': {
      var text = (node.value || '').replace(/\n/g, '<br>');
      if (node.bold) text = '<strong>' + text + '</strong>';
      if (node.italic) text = '<em>' + text + '</em>';
      if (node.underline) text = '<u>' + text + '</u>';
      return text;
    }

    default:
      return node.children ? node.children.map(richTextToHtml).join('') : '';
  }
}

if (!customElements.get('shipping-accordion')) {
  customElements.define('shipping-accordion', class ShippingAccordion extends HTMLElement {
    connectedCallback() {
      this._trigger = this.querySelector('.cart-shipping-accordion__trigger');
      this._body = this.querySelector('.cart-shipping-accordion__body');
      this._contentEl = this.querySelector('[data-shipping-rich-text]');

      if (!this._trigger || !this._body) return;

      this._renderContent();

      this._onClick = () => this.toggle();
      this._trigger.addEventListener('click', this._onClick);

      this._closeOnCartClick = (e) => {
        if (e.target.closest('cart-drawer-items, .cart-items, [data-cart-items], .cart-related-products')) {
          this.close();
        }
      };
      document.addEventListener('click', this._closeOnCartClick);

      this._closeOnDrawerClose = () => this.close();
      document.addEventListener('drawer:closed', this._closeOnDrawerClose);
    }

    disconnectedCallback() {
      if (this._trigger) this._trigger.removeEventListener('click', this._onClick);
      document.removeEventListener('click', this._closeOnCartClick);
      document.removeEventListener('drawer:closed', this._closeOnDrawerClose);
    }

    _renderContent() {
      this.querySelectorAll('[data-shipping-rich-text]').forEach(function(el) {
        var scriptTag = el.querySelector('script[type="application/json"]');
        if (!scriptTag) return;
        try {
          el.innerHTML = richTextToHtml(JSON.parse(scriptTag.textContent));
        } catch (e) {
          el.innerHTML = scriptTag.textContent;
        }
      });
    }

    toggle() {
      this._body.classList.contains('is-open') ? this.close() : this.open();
    }

    open() {
      this._trigger.setAttribute('aria-expanded', 'true');
      this._body.classList.add('is-open');

      // animate 0 -> content height
      this._body.style.maxHeight = this._body.scrollHeight + 'px';

      var onEnd = (e) => {
        if (e.propertyName !== 'max-height') return;
        this._body.style.maxHeight = 'none'; // allow content to grow after open
        this._body.removeEventListener('transitionend', onEnd);
      };
      this._body.addEventListener('transitionend', onEnd);
    }

    close() {
      this._trigger.setAttribute('aria-expanded', 'false');
      this._body.classList.remove('is-open');

      // if max-height is 'none', set fixed px first so transition has a start value
      this._body.style.maxHeight = this._body.scrollHeight + 'px';
      void this._body.offsetHeight; // force reflow

      this._body.style.maxHeight = '0px';
    }
  });
}
